import React, { useEffect, useState } from "react";
import Alert, { AlertColor } from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grow from "@mui/material/Grow"; // Import Grow transition
import { getCookie, setCookie } from "../../utils";

interface MuiProps {
  text: string;
  type: AlertColor;
  sx?: React.CSSProperties;
  shouldUseCookie?: boolean;
  onClose?: () => void;
}

const MuiAlert: React.FC<MuiProps> = ({
  text,
  type,
  sx,
  shouldUseCookie = true,
  onClose,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    if (shouldUseCookie) {
      setCookie("closeMousewheelAlert", "closedByUser");
    }
    setOpen(false);
    onClose && onClose();
  };

  useEffect(() => {
    if (shouldUseCookie) {
      const closeMousewheelAlertCookie = getCookie("closeMousewheelAlert");
      if (closeMousewheelAlertCookie !== "closedByUser") {
        setOpen(true);
      }
      const timer = setTimeout(() => {
        setOpen(false);
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setOpen(true);
    }
  }, []);

  return (
    <>
      {open ? (
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          severity={type}
          variant="outlined"
          sx={sx}
        >
          {text}
        </Alert>
      ) : null}
    </>
  );
};

export default MuiAlert;
